import Editor from "../../Components/common/Editor";
import trans from "./../../../Languages/Languages";
import { Button, Form, Input, Card, message } from "antd";
import { useEffect, useState } from "react";
import API from "../../../API";

const Courses = () => {
  const [studyEditorHtml, setStudyEditorHtml] = useState("");
  const [bottomEditorHtml, setBottomEditorHtml] = useState("");
  const [courseData, setCourseData] = useState();

  const inputValueNames = [
    { key: "videoLectures", text: "video_lecture_text", value: "video_lectures" },
    { key: "liveSession", text: "live_sessions_text", value: "live_sessions" },
    { key: "courseMaterial", text: "course_material_text", value: "course_material" },
    { key: "assignments", text: "assignments_text", value: "assignments" },
    { key: "discussionForm", text: "discussion_forum_text", value: "discussion_forum" },
    { key: "finalExams", text: "final_exam_text", value: "final_exam" },
  ];

  const [courseIncludes, setCourseIncludes] = useState([
    { sectionKey: "videoLecturesLabel", fallbackText: trans.VideoLectures },
    { sectionKey: "liveSessionsLabel", fallbackText: trans.Livesessions },
    { sectionKey: "courseMaterialLabel", fallbackText: trans.Coursematerial },
    { sectionKey: "assignmentsLabel", fallbackText: trans.Assignments },
    { sectionKey: "discussionForumLabel", fallbackText: trans.Discussionforum },
    { sectionKey: "finalExamLabel", fallbackText: trans.FinalExam },
  ]);

  const [textEditorHtml, setTextEditorHtml] = useState([
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
    { value: "" },
  ]);

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const [studyACourseLabel, setStudyACourseLabel] = useState(null);
  const [courseIncludeLabel, setCourseIncludeLabel] = useState(null);
  const [videoLecturesLabel, setVideoLecturesLabel] = useState(null);
  const [liveSessionsLabel, setLiveSessionsLabel] = useState(null);
  const [courseMaterialLabel, setCourseMaterialLabel] = useState(null);
  const [assignmentsLabel, setAssignmentsLabel] = useState(null);
  const [discussionForumLabel, setDiscussionForumLabel] = useState(null);
  const [finalExamLabel, setFinalExamLabel] = useState(null);

  const [renamingSection, setRenamingSection] = useState(null);
  const [editingSection, setEditingSection] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const res = await API.get("/admin/course");
        const course = res.data?.courses;

        const newTextEditorHtml = Object.keys(course)
          .filter((key) => key.endsWith("_text"))
          .map((key) => ({ value: course[key] }));

        setTextEditorHtml(newTextEditorHtml);
        setCourseData(course);
        setStudyEditorHtml(course.about);
        setBottomEditorHtml(course.bottom_text);

        setStudyACourseLabel(res.data?.studyACourseLabel);
        setRenameValue(res.data.studyACourseLabel?.title);
        setCourseIncludeLabel(res.data?.courseIncludeLabel);
        setVideoLecturesLabel(res.data?.videoLecturesLabel);
        setLiveSessionsLabel(res.data?.liveSessionsLabel);
        setCourseMaterialLabel(res.data?.courseMaterialLabel);
        setAssignmentsLabel(res.data?.assignmentsLabel);
        setDiscussionForumLabel(res.data?.discussionForumLabel);
        setFinalExamLabel(res.data?.finalExamLabel);
      } catch (err) {
        message.error("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [refresh]);

  const handleFinish = (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("about", studyEditorHtml);
    formData.append("video_lectures", values.videoLecturesValue);
    formData.append("video_lecture_text", textEditorHtml[0].value);
    formData.append("live_sessions", values.liveSessionValue);
    formData.append("live_sessions_text", textEditorHtml[1].value);
    formData.append("course_material", values.courseMaterialValue);
    formData.append("course_material_text", textEditorHtml[2].value);
    formData.append("assignments", values.assignmentsValue);
    formData.append("assignments_text", textEditorHtml[3].value);
    formData.append("discussion_forum", values.discussionFormValue);
    formData.append("discussion_forum_text", textEditorHtml[4].value);
    formData.append("final_exam", values.finalExamsValue);
    formData.append("final_exam_text", textEditorHtml[5].value);
    formData.append("bottom_text", bottomEditorHtml);

    API.post("/admin/course/update", formData)
      .then(() => {
        message.success("Updated Successfully", 3);
        setRefresh(!refresh);
      })
      .catch(() => message.error("Something went wrong", 3))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const handleClickOutside = () => setShowContextMenu(false);
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleRenameSubmit = async () => {
    let page = {
      studyACourseLabel,
      courseIncludeLabel,
      videoLecturesLabel,
      liveSessionsLabel,
      courseMaterialLabel,
      assignmentsLabel,
      discussionForumLabel,
      finalExamLabel,
    }[editingSection];

    try {
      await API.put(`/admin/pages/slug/${page.slug}`, { title: renameValue });

      const updater = {
        studyACourseLabel: setStudyACourseLabel,
        courseIncludeLabel: setCourseIncludeLabel,
        videoLecturesLabel: setVideoLecturesLabel,
        liveSessionsLabel: setLiveSessionsLabel,
        courseMaterialLabel: setCourseMaterialLabel,
        assignmentsLabel: setAssignmentsLabel,
        discussionForumLabel: setDiscussionForumLabel,
        finalExamLabel: setFinalExamLabel,
      };

      updater[editingSection]?.((prev) => ({ ...prev, title: renameValue }));
      setRenamingSection(null);
      setEditingSection(null);
    } catch {
      message.error("Rename failed");
    }
  };

  const handleTitleRightClick = (e, sectionKey, label) => {
    e.preventDefault();
    setContextMenuPos({ x: e.clientX, y: e.clientY });
    setShowContextMenu(true);
    setEditingSection(sectionKey);
    setRenameValue(label?.title);
  };

  const handleTitleDoubleClick = (sectionKey, label) => {
    setRenamingSection(sectionKey);
    setRenameValue(label?.title);
    setEditingSection(sectionKey);
  };

  const renderEditableTitle = (sectionKey, label, fallbackText) => (
    <div
      className="fw-600 fw-15 mb-2"
      onDoubleClick={() => handleTitleDoubleClick(sectionKey, label)}
      onContextMenu={(e) => handleTitleRightClick(e, sectionKey, label)}
    >
      {renamingSection === sectionKey ? (
        <input
          type="text"
          value={renameValue}
          autoFocus
          onChange={(e) => setRenameValue(e.target.value)}
          onBlur={handleRenameSubmit}
          onKeyDown={(e) => e.key === "Enter" && handleRenameSubmit()}
          style={{ padding: "2px 6px", fontSize: "14px" }}
        />
      ) : (
        label?.title || fallbackText
      )}
    </div>
  );

  return (
    <div className="pages-container">
      <Card bordered={false} className="p-0" loading={loading}>
        {courseData && (
          <Form onFinish={handleFinish}>
            <div className="content-wrapper">
              <div className="bg-content-container">
                {renderEditableTitle("studyACourseLabel", studyACourseLabel, trans.Studyacourse)}
                <Editor
                  key="courseStudys"
                  editorHtml={studyEditorHtml}
                  setEditorHtml={setStudyEditorHtml}
                  handleChange={(html) => setStudyEditorHtml(html)}
                />
              </div>
              {renderEditableTitle("courseIncludeLabel", courseIncludeLabel, trans.Coursesinclude)}

              {courseIncludes.map((courseInclude, index) => {
                const labelObj = {
                  videoLecturesLabel,
                  liveSessionsLabel,
                  courseMaterialLabel,
                  assignmentsLabel,
                  discussionForumLabel,
                  finalExamLabel,
                }[courseInclude.sectionKey];

                return (
                  <CourseInclude
                    key={index}
                    index={index}
                    inputValueNames={inputValueNames}
                    courseData={courseData}
                    courseInclude={courseInclude}
                    label={labelObj}
                    renderEditableTitle={renderEditableTitle}
                    textEditorHtml={textEditorHtml}
                    setTextEditorHtml={setTextEditorHtml}
                  />
                );
              })}
            </div>

            <div className="bg-content-container">
              <div className="fw-600 mb-2">{trans.text}</div>
              <Editor
                key="bottomText"
                editorHtml={bottomEditorHtml}
                setEditorHtml={setBottomEditorHtml}
                handleChange={(html) => setBottomEditorHtml(html)}
              />
            </div>

            <Button className="btn-save-changes" type="primary" htmlType="submit">
              {trans.Save}
            </Button>
          </Form>
        )}
      </Card>

      {showContextMenu && (
        <ul
          style={{
            position: "fixed",
            top: contextMenuPos.y,
            left: contextMenuPos.x,
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: 4,
            listStyle: "none",
            padding: "5px 10px",
            margin: 0,
            zIndex: 1000,
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          }}
          onClick={() => {
            setRenamingSection(editingSection);
            setShowContextMenu(false);
          }}
          onMouseLeave={() => setShowContextMenu(false)}
        >
          <li>{trans.Rename}</li>
        </ul>
      )}
    </div>
  );
};

export default Courses;

const CourseInclude = ({
  index,
  inputValueNames,
  courseData,
  courseInclude,
  textEditorHtml,
  setTextEditorHtml,
  label,
  renderEditableTitle,
}) => {
  const handleTextEditorChange = (html) => {
    const data = [...textEditorHtml];
    data[index].value = html;
    setTextEditorHtml(data);
  };

  return (
    <div className="bg-content-container" key={index}>
      {renderEditableTitle(courseInclude.sectionKey, label, courseInclude.fallbackText)}

      <div className="fw-400 f-12 mb-2">{trans.Value}</div>
      <div className="accordion-detail course-include-value">
        <Form.Item
          name={`${inputValueNames[index].key}Value`}
          initialValue={courseData[inputValueNames[index].value]}
        >
          <Input type="text" placeholder="26" />
        </Form.Item>
      </div>

      <div className="fw-400 f-12 mb-2">{trans.text}</div>
      <Editor
        key={index}
        editorHtml={
          textEditorHtml[index].value !== ""
            ? textEditorHtml[index].value
            : courseData[inputValueNames[index].text]
        }
        handleChange={handleTextEditorChange}
      />
    </div>
  );
};
